var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-row',{staticStyle:{"margin-right":"0px !important","margin-left":"50px !important","padding-top":"10px !important"}},[_c('b-col',{attrs:{"cols":"0","md":"0","xl":"0"}}),_vm._v(" "),_c('b-col',{attrs:{"cols":"12","md":"12","xl":"12"}},[_c('b-card',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26864b32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/layout/SpacedContent.vue
// module id = null
// module chunks = 